module.exports = __webpack_public_path__ + "static/JonLuc-Christensen-2acd772e9aaf0756943ac691a65b72de.jpg";